import { render } from "./messagePop.vue?vue&type=template&id=2962e5c6&scoped=true&ts=true"
import script from "./messagePop.vue?vue&type=script&lang=ts"
export * from "./messagePop.vue?vue&type=script&lang=ts"

import "./messagePop.vue?vue&type=style&index=0&id=2962e5c6&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2962e5c6"]])

export default __exports__